import { message } from 'antd';

import { apiService } from '../services';
const { allBillerApiService } = apiService.getInstance();

const fr = new FileReader();

export const validateFileImage = (info, limitSize) => {
  const { file } = info;

  const isJpgOrPng = file.type === 'image/png';
  if (!isJpgOrPng) {
    message.error('You can only upload PNG file!');
  }
  const isLt2M = file.size / 1024 < limitSize;
  if (!isLt2M) {
    message.error(`Image must smaller than ${limitSize}KB`);
  }

  return isLt2M && isJpgOrPng;
};

export const fileUploaderService = (file, callback, type) => {
  const uid = Date.now();
  const fileExt = file.name.split('.').pop();
  const fileName = `FILES_${uid}.${fileExt}`;
  const bodyFormData = new FormData();
  const info = {
    uid,
    fileExt,
    fileName,
    detailInfo: file,
  };
  bodyFormData.append(type || 'image', file, fileName);

  allBillerApiService
    .post('documents', bodyFormData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then(response => {
      callback(response, info, 'success');
    })
    .catch(response => {
      callback(response, info, 'error');
    });
};

export const onLoadImage = (
  file,
  maxDimension,
  uploadFile,
  invalidCallback,
  img,
) => () => {
  const { width, height } = img;

  if (maxDimension.exact) {
    if (width === maxDimension.width && height === maxDimension.height) {
      message.loading({ content: 'Image Upload...', key: 'imageUpload' });
      uploadFile(file, fr.result);
    } else {
      invalidCallback();
      message.error({
        content: 'Invalid image dimension',
        key: 'imageUpload',
      });
    }
  } else if (width <= maxDimension.width && height <= maxDimension.height) {
    message.loading({ content: 'Image Upload...', key: 'imageUpload' });
    uploadFile(file, fr.result);
  } else {
    invalidCallback();
    message.error({
      content: 'Invalid image dimension',
      key: 'imageUpload',
    });
  }
};

export const fileReader = (
  file,
  maxDimension,
  uploadFile,
  invalidCallback,
) => () => {
  const img = new Image();

  img.onload = onLoadImage(
    file,
    maxDimension,
    uploadFile,
    invalidCallback,
    img,
  );

  img.src = fr.result;
};

export const handleUpload = (
  configImg,
  uploadFile,
  invalidCallback,
) => info => {
  // Check Info Is Real File Or Object String
  if (info.file.type) {
    const { maxSize, maxDimension } = configImg;
    const validFile = validateFileImage(info, maxSize);

    if (validFile) {
      fr.onload = fileReader(
        info.file,
        maxDimension,
        uploadFile,
        invalidCallback,
      );
      fr.readAsDataURL(info.file);
    } else {
      invalidCallback();
      message.error({ content: 'Failed Validation Image', key: 'imageUpload' });
    }
  }
};

export const handleUploadPdf = uploadFile => info => {
  if (info.file.type) {
    uploadFile(info.file, fr.result);
  }
};

const filesUtil = {
  validateFileImage,
  fileUploaderService,
  handleUpload,
  handleUploadPdf,
  fileReader,
  onLoadImage,
};

export default filesUtil;
